import { useAsyncValue, useRequestConnectedToAsyncValue } from '../../../hooks';
import { post } from '../../../redux/api';
import type { LicenseDisputeRequest, LicenseDisputeResponse } from '../../../../shared/issuesV2';

const createLicenseDispute = (issueId: number, req: LicenseDisputeRequest, onSuccess?: () => void) => {
  return post<LicenseDisputeRequest, LicenseDisputeResponse>(`/api/v2/issues/${issueId}/disputes`, req)
    .then((value) => {
      if (onSuccess) {
        onSuccess();
      }
      return value;
    });
};

/**
 * Hook to be used to create a new license dispute.
 */
function useCreateLicenseDispute() {
  const createLicenseDisputeValue = useAsyncValue<LicenseDisputeResponse>(null);
  const onCreateLicenseDispute = useRequestConnectedToAsyncValue(createLicenseDispute, createLicenseDisputeValue);

  return {
    onCreateLicenseDispute,
    onResetErrors: createLicenseDisputeValue.empty,
    createLicenseDisputeResponse: createLicenseDisputeValue.value,
    createLicenseDisputeErrors: createLicenseDisputeValue.errors,
    isCreating: createLicenseDisputeValue.isLoading,
  };
}

export default useCreateLicenseDispute;
